import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  static values = { country: String, packageType: String }

  // outlet API: called by admin--quotes--marketing-package-form via the included item outlet
  // Offers the item for a package of its country and type. Any other item is unticked, so the package does not keep it.
  showFor(country, packageType) {
    const shown = country === this.countryValue && packageType === this.packageTypeValue
    this.element.hidden = !shown

    if (!shown) this.checkboxTarget.checked = false
  }
}
